import React, { useEffect } from "react"
import { useImmerReducer } from "use-immer"
import Axios from "axios"

// My Components
import { SingleMovieHero, MovieCard, Icon, LastSeason, Actor, Page, Breadcrumb, Rating } from "../../components"
import { Section, Grid } from "../../containers"
import { useParams } from "react-router-dom"
import { calcTime } from "../../helpers/calculate"
import { API_URL, API_KEY, IMAGE_BASE_URL, BACKDROP_SIZE, POSTER_SIZE } from "../../helpers/config"

function Tv() {
  const { tvId } = useParams()
  const NoImage = "https://i.ibb.co/bmkvfbv/No-image.jpg"
  const initialState = {
    tv: {
      backdrop_path: "",
      created_by: [],
      episode_run_time: [],
      first_air_date: "2010-10-31",
      genres: [
        {
          id: "",
          name: "",
        },
      ],
      homepage: "",
      id: "",
      in_production: "",
      languages: [],
      last_air_date: "",
      last_episode_to_air: {
        air_date: "",
        episode_number: "",
        id: "",
        name: "",
        overview: "",
        production_code: "",
        season_number: "",
        still_path: "",
        vote_average: "",
        vote_count: "",
      },
      name: "",
      next_episode_to_air: {
        air_date: "",
        episode_number: "",
        id: "",
        name: "",
        overview: "",
        production_code: "",
        season_number: "",
        still_path: "",
        vote_average: "",
        vote_count: "",
      },
      networks: [],
      number_of_episodes: "",
      number_of_seasons: "",
      origin_country: [],
      original_language: "",
      original_name: "",
      overview: "",
      popularity: "",
      poster_path: "",
      production_companies: [],
      production_countries: [],
      seasons: [
        {
          air_date: "",
          episode_count: "",
          id: "",
          name: "",
          overview: "",
          poster_path: "",
          season_number: "",
        },
      ],
      spoken_languages: [],
      status: "",
      tagline: "",
      type: "",
      vote_average: "",
      vote_count: "",
    },
    credit: {
      id: "",
      cast: [
        {
          adult: "",
          gender: "",
          id: "",
          known_for_department: "",
          name: "",
          original_name: "",
          popularity: "",
          profile_path: "",
          cast_id: "",
          character: "",
          credit_id: "",
          order: "",
        },
      ],
      crew: [
        {
          adult: false,
          gender: "",
          id: "",
          known_for_department: "",
          name: "",
          original_name: "",
          popularity: "",
          profile_path: "",
          credit_id: "",
          department: "",
          job: "",
        },
      ],
    },
    director: {
      adult: "",
      gender: "",
      id: "",
      known_for_department: "",
      name: "",
      original_name: "",
      popularity: "",
      profile_path: "",
      credit_id: "",
      department: "",
      job: "",
    },
    isFetching: true,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadSeriesInfo":
        draft.tv = action.data
        return
      case "loadMovieCredit":
        draft.credit = action.data
        return
      case "whosDirector":
        draft.director = action.data
        return
      case "isFetching":
        draft.isFetching = action.value
        return
      default:
        console.log("default")
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  const fetchSeriesInfo = async (ourRequest) => {
    try {
      const response = await Axios.get(`${API_URL}tv/${tvId}?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (response.data) {
        dispatch({ type: "loadSeriesInfo", data: response.data })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMoviecredit = async (ourRequest) => {
    try {
      const response = await Axios.get(`${API_URL}tv/${tvId}/credits?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (response.data) {
        dispatch({ type: "loadMovieCredit", data: response.data })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRequest = Axios.CancelToken.source()
    fetchSeriesInfo(ourRequest)
    fetchMoviecredit(ourRequest)

    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tvId])

  return (
    <Page title={state.tv.name} disc={state.tv.overview}>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item title={state.tv.name} />
        </Breadcrumb.List>
      </Breadcrumb>
      <SingleMovieHero path={state.tv.backdrop_path ? `${IMAGE_BASE_URL}${BACKDROP_SIZE}${state.tv.backdrop_path}` : ""}>
        <SingleMovieHero.Thumbnail src={state.tv.poster_path} />
        <SingleMovieHero.Content>
          <Rating rate={state.tv.vote_average} />
          <SingleMovieHero.Name year={state.tv.first_air_date.substring(0, 4)}>{state.tv.name}</SingleMovieHero.Name>
          <SingleMovieHero.TimeAndDate>
            <SingleMovieHero.IconWithText icon="ph-clock" text={calcTime(state.tv.episode_run_time)} />
            <SingleMovieHero.IconWithText icon="ph-calendar-blank" text={state.tv.first_air_date} />
          </SingleMovieHero.TimeAndDate>
          <SingleMovieHero.Title>Overview</SingleMovieHero.Title>
          <SingleMovieHero.OverviewText>{state.tv.overview}</SingleMovieHero.OverviewText>
        </SingleMovieHero.Content>
      </SingleMovieHero>

      <Section>
        <Section.Wrapper>
          <Section.Head>
            <Section.Left>
              <Section.Title>Current Season</Section.Title>
              <Icon name="ph-television-simple" size="16" color="#000" />
            </Section.Left>
          </Section.Head>
          <Section.Body>
            {state.tv.seasons[0].name !== "" && (
              <LastSeason>
                <LastSeason.Content>
                  <LastSeason.Title date={state.tv.seasons[state.tv.seasons.length - 1].air_date !== null ? state.tv.seasons[state.tv.seasons.length - 1].air_date.substring(0, 4) : state.tv.seasons[state.tv.seasons.length - 1].air_date}>{state.tv.name}</LastSeason.Title>
                  <LastSeason.SeasonAndDate>
                    <LastSeason.IconWithText icon="ph-stack" text={`Season ${state.tv.seasons.length - 1}`} />
                    <LastSeason.IconWithText icon="ph-calendar-blank" text={state.tv.seasons && state.tv.seasons[state.tv.seasons.length - 1].air_date} />
                  </LastSeason.SeasonAndDate>
                  <LastSeason.Episode>{state.tv.seasons[state.tv.seasons.length - 1].episode_count} Episode</LastSeason.Episode>
                  <LastSeason.Subtitle>Overview</LastSeason.Subtitle>
                  <LastSeason.Text>{state.tv.seasons[state.tv.seasons.length - 1].overview ? state.tv.seasons[state.tv.seasons.length - 1].overview : "No overview available yet."}</LastSeason.Text>
                </LastSeason.Content>
                <LastSeason.Thumbnail src={state.tv.seasons[state.tv.seasons.length - 1].poster_path} />
              </LastSeason>
            )}
          </Section.Body>
        </Section.Wrapper>
      </Section>

      <Section bg="gray">
        <Section.Wrapper>
          <Section.Head>
            <Section.Left>
              <Section.Title>Seasons</Section.Title>
              <Icon name="ph-television-simple" size="16" color="#000" />
              <Section.Count>{state.tv.seasons.length > 1 ? state.tv.seasons.length - 1 : "1"}</Section.Count>
            </Section.Left>
          </Section.Head>
          <Section.Body>
            <Section.ScrollContainer>
              {state.tv.seasons &&
                state.tv.seasons.map((season) => {
                  if (season.name === "Specials") {
                    return ""
                  }

                  return (
                    <MovieCard key={season.id} to={"#"}>
                      <MovieCard.Thumb to={`movie/${season.id}`}>
                        <MovieCard.Rating count={`${season.episode_count} Episode`} />
                        <MovieCard.Image path={season.poster_path && season.poster_path !== null ? `${IMAGE_BASE_URL}${POSTER_SIZE}${season.poster_path}` : NoImage} />
                      </MovieCard.Thumb>
                      <MovieCard.Info isTv={true}>
                        <MovieCard.Title>{season.name}</MovieCard.Title>
                        <MovieCard.Date>{season.air_date}</MovieCard.Date>
                      </MovieCard.Info>
                    </MovieCard>
                  )
                })}
            </Section.ScrollContainer>
          </Section.Body>
        </Section.Wrapper>
      </Section>

      <Grid title="Series Cast">
        <Grid.Body>
          {state.credit.cast.map((cast) => {
            return (
              <Actor key={cast.id} to={`/actor/${cast.id}`}>
                <Actor.Thumbnail src={cast.profile_path && cast.profile_path !== "null" ? `${IMAGE_BASE_URL}${POSTER_SIZE}${cast.profile_path}` : NoImage} />
                <Actor.Name>{cast.original_name}</Actor.Name>
                <Actor.InMovieName>{cast.character}</Actor.InMovieName>
              </Actor>
            )
          })}
        </Grid.Body>
      </Grid>
    </Page>
  )
}

export default Tv
